import _regeneratorRuntime from "@babel/runtime/regenerator";
import "regenerator-runtime/runtime.js";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
// import
import { useState, useMemo, useEffect } from 'react';
import { useQuery } from '@apollo/client';
import { useApolloNetworkStatus } from '@meepshop/apollo';
import useCart from "@meepshop/hooks/lib/useCart";
import filter from '@meepshop/utils/lib/filter'; // graphql import

import { useCartFragment } from '@meepshop/hooks/lib/gqls/useCart';
import { getCart, useInitialCartFragment } from "../gqls/useInitialCart"; // definition

var useInitialCart = function useInitialCart() {
  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      mergingCart = _useState2[0],
      setMergingCart = _useState2[1];

  var _useApolloNetworkStat = useApolloNetworkStatus(),
      numPendingQueries = _useApolloNetworkStat.numPendingQueries;

  var _useQuery = useQuery(getCart),
      data = _useQuery.data,
      client = _useQuery.client;

  var _useCart = useCart(useMemo(function () {
    return filter(useCartFragment, (data === null || data === void 0 ? void 0 : data.viewer) || null);
  }, [data])),
      cartItems = _useCart.cartItems,
      upsertCart = _useCart.upsertCart;

  useEffect(function () {
    var _data$viewer;

    if (!mergingCart && (data === null || data === void 0 ? void 0 : (_data$viewer = data.viewer) === null || _data$viewer === void 0 ? void 0 : _data$viewer.role) === 'SHOPPER' && numPendingQueries === 0 && ((data === null || data === void 0 ? void 0 : data.viewer.guestCart.cartItems) || []).length !== 0) {
      setMergingCart(true);

      _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return upsertCart(cartItems);

              case 2:
                setMergingCart(false);

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    }
  }, [data, cartItems, mergingCart, upsertCart, numPendingQueries]);
  useEffect(function () {
    var _data$viewer2, _data$viewer3;

    client.writeFragment({
      id: (data === null || data === void 0 ? void 0 : (_data$viewer2 = data.viewer) === null || _data$viewer2 === void 0 ? void 0 : _data$viewer2.id) || null
      /* SHOULD_NOT_BE_NULL */
      ,
      fragment: useInitialCartFragment,
      fragmentName: 'useInitialCartFragment',
      data: {
        __typename: 'User',
        id: (data === null || data === void 0 ? void 0 : (_data$viewer3 = data.viewer) === null || _data$viewer3 === void 0 ? void 0 : _data$viewer3.id) || null
        /* SHOULD_NOT_BE_NULL */
        ,
        guestCart: {
          __typename: 'GuestCart',
          cartItems: JSON.parse(localStorage.getItem('guestCart') || '[]')
        }
      }
    });
  }, [data, client]);
};

export default useInitialCart;